import { CheckoutIntentKind } from '../types';

type IntentKindCandidate = {
  multisetID?: string | null;
};

export const resolveCheckoutIntentKind = (
  draw: IntentKindCandidate | null | undefined,
): CheckoutIntentKind | null => {
  if (!draw) return null;

  return draw.multisetID ? 'linked' : 'single';
};
